import { Button } from '@src/design-system/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@src/design-system/tooltip';
import { StarSlash } from 'iconsax-react';
import { Check, Star } from 'lucide-react';
import type { FC } from 'react';

type TProps = {
  content: string;
  disabled?: boolean;
  lastItem?: boolean;
  basic?: boolean;
};

const PricingListItem: FC<TProps> = ({
  content,
  disabled,
  lastItem,
  basic,
}) => {
  return (
    <li
      className={`flex items-center gap-4 mb-3 ${disabled ? 'disabled' : ''}`}
    >
      <Button
        size='iconSm'
        disabled={disabled}
        variant='primaryPale'
        className='rounded-full border-0'
      >
        {lastItem ? (
          <Tooltip>
            <TooltipTrigger className='cursor-pointer'>
              {basic ? (
                <StarSlash
                  color='#5B31AA'
                  variant='Bold'
                />
              ) : (
                <Star fill='#5B31AA' />
              )}
            </TooltipTrigger>
            <TooltipContent>
              <ul
                className='text-gray-900 text-sm font-medium list-disc list-inside'
                style={{ listStyle: 'unset' }}
              >
                <li
                  className='mb-1'
                  style={{ listStyle: 'inside' }}
                >
                  Programs Management
                </li>
                <li
                  className='mb-1'
                  style={{ listStyle: 'inside' }}
                >
                  Participants Management
                </li>
                <li
                  className='mb-1'
                  style={{ listStyle: 'inside' }}
                >
                  Leads Management
                </li>
                <li
                  className='mb-1'
                  style={{ listStyle: 'inside' }}
                >
                  Placements Management
                </li>
                <li
                  className='mb-1'
                  style={{ listStyle: 'inside' }}
                >
                  Dashboard & Reports
                </li>
              </ul>
            </TooltipContent>
          </Tooltip>
        ) : (
          <>
            {!disabled ? (
              <Check color='#5B31AA' />
            ) : (
              <span className='text-lg !text-primary-1000'>x</span>
            )}
          </>
        )}
      </Button>
      {content}
    </li>
  );
};

export default PricingListItem;
